<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-2 mb-2">
      <div class="col content-block">
        <h3>New Subcontractor / Depot</h3>
      </div>
    </div>

    <app-subcontractor-form
      [workshopSubcontractor]='this.workshopSubcontractor'
      [subcontractorId]='this.subcontractorId'
      [editable]='this.isEditable'
    ></app-subcontractor-form>

    @if (this.isEditable) {
      <div class="row mt-2">
        <div class="col">
          <button class='btn btn-success' (click)='save();'>Save</button>
          <button class='btn btn-warning' (click)='cancel();'>Cancel</button>
        </div>
      </div>
    }
  </div>
</div>
